// src/components/common/AIAssistantIcon.tsx
import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const AIAssistantIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" fill="currentColor" fillOpacity="0.1" stroke="currentColor" strokeWidth="1.5" />
      
      {/* Abstract AI wave pattern */}
      <path d="M7 14.5c1.5 1.5 3 1.5 4.5 0s3-1.5 4.5 0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7 11.5c1.5 1.5 3 1.5 4.5 0s3-1.5 4.5 0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7 8.5c1.5 1.5 3 1.5 4.5 0s3-1.5 4.5 0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
  );
};

export default AIAssistantIcon;